import { Component, Inject } from '@angular/core';
import { FormBuilder, FormControl, FormGroup, Validators } from '@angular/forms';
import { MAT_DIALOG_DATA, MatDialog, MatDialogRef } from '@angular/material/dialog';
import { IBillingCycle } from 'src/app/services/products-subproject/products-subproject.service';

interface DialogData {
  productId: string;
  resourceId: string;
  billingCycleInfo: { billingCycleId: number; billingDay?: number } | null;
  billingCycles: IBillingCycle[];
  saveFunction: (data: {
    resourceId: string;
    productId: string;
    billingCycleId: number | null;
    billingDay?: number;
  }) => Promise<void>;
}

@Component({
  selector: 'app-billing-cycle-modal',
  templateUrl: './billing-cycle-modal.component.html',
  styleUrls: ['./billing-cycle-modal.component.scss'],
})
export class BillingCycleModalComponent {
  public form!: FormGroup;

  get billingCycleControl() {
    return this.form.get('billingCycle') as FormControl;
  }
  get billingDayControl() {
    return this.form.get('billingDay') as FormControl;
  }

  constructor(
    private readonly formBuilder: FormBuilder,
    private readonly dialogRef: MatDialogRef<BillingCycleModalComponent>,
    @Inject(MAT_DIALOG_DATA) public data: DialogData,
  ) {
    this.initializeForm();
    this.populateForm();
  }

  private initializeForm(): void {
    this.form = this.formBuilder.group({
      billingCycle: ['', Validators.required],
      billingDay: [''],
    });
    this.form.get('billingCycle')?.valueChanges.subscribe((value) => {
      const selectedCycle = this.data.billingCycles.find((cycle) => cycle.id === value);
      if (selectedCycle && selectedCycle.type === 'fixedBilling') {
        this.billingDayControl.setValidators([
          Validators.required,
          Validators.min(1),
          Validators.max(31),
        ]);
      } else {
        this.billingDayControl.clearValidators();
      }
      this.billingDayControl.updateValueAndValidity();
    });
  }

  public populateForm() {
    if (this.data.billingCycleInfo) {
      this.form.patchValue({
        billingCycle: this.data.billingCycleInfo.billingCycleId,
        billingDay: this.data.billingCycleInfo.billingDay,
      });
    }
  }

  public async save() {
    try {
      const billingCycleId = this.billingCycleControl.value;
      const billingDay = this.billingDayControl.value;
  
      await this.data.saveFunction({
        resourceId: this.data.resourceId,
        productId: this.data.productId,
        billingCycleId,
        billingDay: billingDay ? billingDay : undefined,
      });
      this.dialogRef.close(true);
    } catch (e) {
      console.error('Error saving billing cycle:', e);
    }
  }

  public async resetToDefault() {
    try {
      console.log('Resetting billing cycle to default');
      await this.data.saveFunction({
        resourceId: this.data.resourceId,
        productId: this.data.productId,
        billingCycleId: null,
      });
      this.dialogRef.close(true);
    } catch (e) {
      console.error('Error resetting billing cycle to default:', e);
    }
  }
}
